import Webhook from "../../services/webhook.js";
import { Refresh } from "../../services/refreshToken.js";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    webhooks: [],
    page: 1,
    total: 0,
    visible: 7,
    rowsPerPage: 10,
    errored: false,
    error: false,
    cargando: false,
    fechaInicio: moment()
      .subtract(1, "months")
      .format("YYYY-MM-DD"),
    fechaFin: moment().format("YYYY-MM-DD"),

    estado: "TODOS",
    referencia_externa: "",
    medio_pago: "TODOS",
    medios_pagos: [],
    estados_pagos: [],
    detallePago: null,
  },
  mutations: {
    setWebhooks(state, webhooks) {
      state.webhooks = webhooks;
    },

    setDetallePago(state, payload) {
      state.detallePago = payload;
    },

    setFechaInicio(state, fecha) {
      state.fechaInicio = fecha;
    },

    setFechaFin(state, fecha) {
      state.fechaFin = fecha;
    },

    setReferencia(state, value) {
      state.referencia_externa = value;
    },

    setEstado(state, value = []) {
      state.estado = value;
    },

    setMedioPago(state, value) {
      state.medio_pago = value;
    },

    setMediosPagos(state, medios_pagos) {
      state.medios_pagos = medios_pagos;
    },
    setEstadosPagos(state, estados_pagos) {
      state.estados_pagos = estados_pagos;
    },
    
    setCargando(state, value) {
      state.cargando = value;
    },

    setPaginate(state, value) {
        state.page = value;
      },
  
    setrowsPerPage(state, value) {
      state.rowsPerPage = value;
    },
    setErrord(state, value) {
      state.errored = value;
    },
    setTotal(state, value) {
      state.total = value;
    },
  },
  actions: {

    setFechaInicio({ commit }, fecha) {
      commit("setFechaInicio", fecha);
    },

    setFechaFin({ commit }, fecha) {
      commit("setFechaFin", fecha);
    },

     setDetallePago({ commit }, payload) {
      commit("setDetallePago", payload);
    },
    
    async getWebhooks({ commit,rootGetters, state }) {
      try {
        const params = {
            Number: state.page,
            Size: state.rowsPerPage,
            ApiKey: window.atob(rootGetters["getAccountApikeyById"]),
            FechaInicio: state.fechaInicio + 'T00:00:00Z',
            FechaFin: state.fechaFin + 'T23:59:59Z',
        };
        if (state.referencia_externa) {
          params.ExternalReference = state.referencia_externa;
        }
        
        if(state.medio_pago !== "TODOS" && state.medio_pago !== "") {
          params.Channel = state.medio_pago;
        }
        if(state.estado !== "TODOS" && state.estado !== "") {
          params.EstadoPago = state.estado;
        }
        commit("setCargando", true);

        const response = await Webhook.getWebhook(params);


        if (response?.data?.pagos == null) {
          commit("setWebhooks", []);
          commit("setPaginate", 1);
          commit("setTotal", 0);
        } else {
          commit("setWebhooks", response?.data?.pagos);
          commit("setPaginate", response?.data?.meta?.page.currentPage);
          commit("setTotal", response?.data?.meta?.page.lastPage);
        }
      } catch (error) {
        if (error.response && error.response.status === 403) {
          try {
            await Refresh.getRefreshToken();
            return await dispatch("getWebhooks");
          } catch (refreshError) {
            // console.error("Error al obtener el token de refresco:", refreshError);
          }
        } else {
          commit("setErrord", true);
        }
      } finally {
        commit("setCargando", false);
      }
    },
    
  },
  getters: {

    canalespago(state) {
      state.medios_pagos.unshift({
        Id: 0,
        Nombre: "TODOS",
        Channel: "TODOS",
      });
      return state.medios_pagos;
    },

    estadoPagos(state) {
      state.estados_pagos.unshift({
        Id: 0,
        nombre: "TODOS",
      });
      return state.estados_pagos;
    },


    webhooks: (state) => state.webhooks,
    pages: (state) => state.page,
    fechaInicio: (state) => state.fechaInicio,
    fechaFin: (state) => state.fechaFin,
    // rowsPerPage: (state) => state.rowsPerPage,
    errored: (state) => state.errored,
    error: (state) => state.error,
    cargando: (state) => state.cargando,
    detallePago: (state) => state.detallePago,
    
  },
  modules: {},
};
